import React from 'react'
import injectSheet from 'react-jss'
import style from 'components/Panel/style'

class Panel extends React.Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.props.updateUiAction({ [this.props.uiKey]: !this.props.active })
  }

  render() {
    const { classes } = this.props
    const stateStyle = this.props.active ? 'active' : 'inactive'
    return (
      <div>
        <div className={classes.header}>
          <a onClick={this.toggle} className={classes.link}>
            <div className={classes.triangleContainer} >
              <div className={classes[`triangle-${stateStyle}`]} />
            </div>
            {this.props.title}
          </a>
        </div>
        <section className={classes[`Panel-${stateStyle}`]}>
          <div className={classes[stateStyle]}>
            {this.props.component}
          </div>
        </section>
      </div>
    )
  }
}

export default injectSheet(style)(Panel)



// WEBPACK FOOTER //
// ./src/components/Panel/index.js